angular.module('unica_media_directory.media_directory_controllers')

.controller('ArchiveMediaDirectoryEditController', function(
	$rootScope, $scope, $state, $stateParams,
	MediaDirectoryEditService
) {

	$scope.archive = true;

	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );

	$rootScope.getMediaDirectory( $stateParams.id );

	$scope.pageTitle = 'Modifica Directory Archivio';

	console.log($state.current.name);

	$rootScope.mediaDirectoryData = {
		event_id: $stateParams.event_id,
		title: ''
	};

	$scope.saveMediaDirectory = function() {
		$scope.showLoader();

		var mediaDirectoryData = angular.copy($rootScope.mediaDirectoryData);

		mediaDirectoryData.archive = 1;

		console.log(mediaDirectoryData);
		

		MediaDirectoryEditService
			.update(mediaDirectoryData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Archivio Media Directory aggiornata con successo!', '');
					if ( $state.current.name === 'app.archive_event.directory_edit' ) {
						$state.go('app.archive_event.directory_list', { year: $rootScope.year, event_id: $stateParams.event_id });
					} else {
						$state.go('app.archive_media_directory.list', { event_id: $stateParams.event_id });
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

})

;